import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

export default function CommerceSiteDestinationModal({
  open,
  siteId,
  siteTitle,
  onClose,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open || !siteId) return null;

  const goEditor = () => {
    onClose?.();
    navigate(`/web-creator/edit/${siteId}`);
  };

  const goAdmin = () => {
    onClose?.();
    navigate(`/web-creator/edit/${siteId}/administration`);
  };

  const modal = (
    <div
      className="fixed inset-0 z-[1200] flex items-center justify-center bg-black/55 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="wc-dest-modal-title"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl border border-border bg-card shadow-elevation-3 overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 pt-5 pb-3 border-b border-border">
          <h2 id="wc-dest-modal-title" className="text-lg font-semibold text-foreground">
            Ouvrir le site
          </h2>
          <p className="text-sm text-muted-foreground mt-1 truncate">
            {siteTitle || 'Sans titre'}
          </p>
        </div>
        <div className="p-5 grid gap-3">
          <button
            type="button"
            onClick={goAdmin}
            className="flex items-start gap-4 rounded-xl border border-border bg-muted/30 hover:bg-muted/60 hover:border-primary/30 transition-colors p-4 text-left"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <Icon name="Store" size={22} />
            </span>
            <span>
              <span className="block text-sm font-semibold text-foreground">
                Administration
              </span>
              <span className="block text-xs text-muted-foreground mt-0.5 leading-relaxed">
                Commandes, réservations, menu et réglages commerce.
              </span>
            </span>
          </button>
          <button
            type="button"
            onClick={goEditor}
            className="flex items-start gap-4 rounded-xl border border-border bg-muted/30 hover:bg-muted/60 hover:border-primary/30 transition-colors p-4 text-left"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-foreground/5 text-foreground">
              <Icon name="Pencil" size={22} />
            </span>
            <span>
              <span className="block text-sm font-semibold text-foreground">
                Éditeur de page
              </span>
              <span className="block text-xs text-muted-foreground mt-0.5 leading-relaxed">
                Contenu, design et publication du site.
              </span>
            </span>
          </button>
        </div>
        <div className="px-5 pb-5">
          <button
            type="button"
            className="w-full text-sm text-muted-foreground hover:text-foreground py-2"
            onClick={onClose}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
